// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const getImageBaseSixFour = async (imgUrl: string) => {
  try {
    const recordRequest = await axios.post(
      `/api/shared/get-image-base-six-four`,
      {
        data: {
          imgUrl: imgUrl
        }
      }
    );
    const { data } = recordRequest;
    return data;
  } catch (error) {
    console.error("Utils - Get base64 image - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.LOAD_IMAGE);
  }
};

export default getImageBaseSixFour;
